import React from "react";
import { DiseaseMenuSection, diseaseMenuSectionId } from "./DiseaseMenuSection";
import { ItemContents } from "./ItemContents";

export const DetailContent = React.memo(function DetailContent(props: Props) {
    const {
        menuSection,
        elementRef,
        itemName,
        itemContents
    } = props;

    return (
        <>
            <h3 className={"itemName"} id={diseaseMenuSectionId(menuSection)} ref={elementRef}>{itemName}</h3>
            <ItemContents itemContents={itemContents} />
        </>
    );
});

type Props = {
    menuSection: DiseaseMenuSection
    elementRef: React.RefObject<HTMLHeadingElement>
    itemName: string
    itemContents: string[]
};
